module.exports = __webpack_public_path__ + "media/images/lb/500-065a4abf638b0d2b3683a9961792bd3f.svg";